require('./').install();



/*****************
 ** WEBPACK FOOTER
 ** ./app/~/source-map-support/register.js
 ** module id = 1
 ** module chunks = 0
 **/